module.exports = __webpack_public_path__ + "img/avatar_batman.de367ef1.svg";